import React, { memo,useEffect } from "react";
import { useDispatch,useSelector,shallowEqual } from "react-redux";
import { getData_Action } from "./store/actions";
import { renderRoutes } from "react-router-config";

import { Start,isWx,setWxshare} from './tools';
import routes from "./router";



export default memo(function App() {

// 获取数据存放在redux中
const dispatch = useDispatch();
useEffect(() => {
  dispatch(getData_Action());
}, [dispatch]);

// 获取到redux中的数据
const {data} = useSelector(state =>({
  data:state
}),shallowEqual)


useEffect(() => {
  Start(data);
}, [data])

  // 分享
useEffect(() => {
  if (data.companyID && isWx()) {
    setWxshare(data);
  }
}, [data]);

  return (
    <>
      {renderRoutes(routes)}
    </>
  );
});
